<template>
	<div
		class="p-d-flex p-flex-column p-flex-md-row p-text-left p-justify-center p-grid"
	>
		<Accordion class="p-col-12" :activeIndex="active">
			<AccordionTab>
				<template #header>
					<div class="p-d-flex p-justify-between" style="width: 100%">
						<p>
							{{
								firstName && lastName != null
									? firstName + " " + lastName
									: "Location #" + locationNumber
							}}
						</p>
						<p>
							Total: CAD $<span>{{ locationTotalAmount.toFixed(2) }}</span>
						</p>
					</div>
				</template>

				<div class="p-fluid p-grid p-formgrid p-text-left p-jc-center">
					<div
						class="p-field p-d-flex p-ai-center p-jc-center p-flex-column p-flex-md-row p-col-12 p-mb-4 p-p-0"
					>
						<div
							class="p-d-flex p-flex-column p-flex-md-row p-jc-between p-col-12"
						>
							<h2 class="p-text-underline p-text-center">Delivery Details</h2>

							<div
								class="p-d-flex p-flex-column p-flex-md-row p-jc-end p-ai-center"
							>
								<div class="p-d-flex p-flex-column">
									<label class="p-text-bold"> Smile Cookies ($24/Dozen) </label>
									<small>Minimum Order - 3 dozens/location</small>
								</div>

								<div class="p-col-8 p-sm-6 p-md-4 p-mt-2 p-mt-md-0">
									<InputNumber
										id="horizontal"
										v-model="cookiesQuantityDozens"
										showButtons
										buttonLayout="horizontal"
										incrementButtonIcon="pi pi-plus"
										decrementButtonIcon="pi pi-minus"
										:min="3"
										placeholder="Quantity in dozens (Min 5)"
									/>
								</div>
								<small
									v-if="v$.cookiesQuantityDozens.$invalid && submitted"
									class="p-error p-text-bold"
								>
									{{
										v$.cookiesQuantityDozens.minValue.$message.replace(
											"The minimum value allowed is 5",
											"The minimum quantity required is 5 dozens"
										)
									}}
								</small>
							</div>
						</div>
					</div>

					<div class="p-field p-mt-2 p-mb-0 p-text-left p-col-12">
						<label class="p-text-bold">
							Is it a residential address or business address? *
						</label>

						<div class="p-d-flex p-flex-row">
							<div class="p-field-radiobutton p-mr-5">
								<RadioButton
									:id="locationNumber + 'Residential'"
									value="Residential"
									v-model="deliveryAddressTypeRB"
								/>
								<label :for="locationNumber + 'Residential'">Residential</label>
							</div>

							<div class="p-field-radiobutton">
								<RadioButton
									:id="locationNumber + 'Company'"
									value="Company"
									v-model="deliveryAddressTypeRB"
								/>
								<label :for="locationNumber + 'Company'">Business</label>
							</div>
						</div>
						<div
							v-if="deliveryAddressTypeRB == 'Company'"
							class="p-field p-col-12 p-sm-6 p-pl-0 p-py-0"
						>
							<label for="companyName" class="p-text-bold">Company Name*</label>

							<InputText
								id="companyName"
								v-model="companyName"
								placeholder="Company Name"
								type="text"
							/>

							<small
								v-if="v$.companyName.$invalid && submitted"
								class="p-error p-text-bold"
							>
								{{
									v$.companyName.required.$message.replace(
										"Value",
										"Company Name"
									)
								}}
							</small>
						</div>
					</div>

					<div class="p-field p-mb-3 p-col-12 p-sm-6">
						<label for="firstName" class="p-text-bold">First Name *</label>

						<InputText
							id="firstName"
							v-model="firstName"
							placeholder="First Name"
							type="text"
						/>

						<small
							v-if="v$.firstName.$invalid && submitted"
							class="p-error p-text-bold"
						>
							{{
								v$.firstName.required.$message.replace("Value", "First Name")
							}}
						</small>
					</div>

					<div class="p-field p-mb-3 p-col-12 p-sm-6">
						<label for="lastName" class="p-text-bold">Last Name *</label>

						<InputText
							id="lastName"
							v-model="lastName"
							placeholder="Last Name"
							type="text"
						/>

						<small
							v-if="v$.lastName.$invalid && submitted"
							class="p-error p-text-bold"
						>
							{{ v$.lastName.required.$message.replace("Value", "Last Name") }}
						</small>
					</div>

					<div class="p-field p-mb-3 p-col-12 p-sm-6">
						<label for="address" class="p-text-bold">Address *</label>
						<AutoComplete
							id="address"
							v-model="address"
							field="name"
							placeholder="Address"
							:suggestions="filteredAddresses"
							@complete="searchAddress($event)"
							@item-select="populateFields($event)"
						/>

						<small
							v-if="v$.address.$invalid && submitted"
							class="p-error p-text-bold"
						>
							{{ v$.address.required.$message.replace("Value", "Address") }}
						</small>
					</div>

					<div class="p-field p-mb-3 p-col-12 p-sm-6">
						<label for="address2" class="p-text-bold">Address 2</label>
						<InputText
							id="address2"
							v-model="address2"
							placeholder="Apartment, Suite, ..."
							type="text"
						/>
					</div>

					<div class="p-field p-mb-3 p-col-12 p-sm-4">
						<label for="city" class="p-text-bold">City *</label>

						<InputText
							id="city"
							v-model="city"
							placeholder="City"
							type="text"
						/>

						<small
							v-if="v$.city.$invalid && submitted"
							class="p-error p-text-bold"
						>
							{{ v$.city.required.$message.replace("Value", "City") }}
						</small>
					</div>

					<div class="p-field p-mb-3 p-col-12 p-sm-4">
						<label for="province" class="p-text-bold">Province *</label>

						<div>
							<Dropdown
								id="province"
								v-model="selectedProvince"
								:options="filteredProvinceState"
								optionLabel="name"
							/>
						</div>

						<small
							v-if="v$.selectedProvince.$invalid && submitted"
							class="p-error p-text-bold"
						>
							{{
								v$.selectedProvince.required.$message.replace(
									"Value",
									"Province"
								)
							}}
						</small>
					</div>

					<div class="p-field p-mb-3 p-col-12 p-sm-4">
						<label for="postalCode_zip" class="p-text-bold"
							>Postal Code *</label
						>

						<InputMask
							id="postalCode_zip"
							v-model="postalCode_zip"
							:class="postalCode_zip ? 'p-text-uppercase' : ''"
							:placeholder="'Postal Code'"
							slotChar=""
							mask="a9a 9a9"
						/>

						<small
							v-if="v$.postalCode_zip.$invalid && submitted"
							class="p-error p-text-bold"
						>
							{{
								v$.postalCode_zip.required.$message.replace(
									"Value",
									"Postal Code"
								)
							}}
						</small>
					</div>

					<div class="p-field p-mb-3 p-col-12 p-sm-6">
						<label for="email" class="p-text-bold">Email</label>

						<InputText
							id="email"
							v-model="email"
							placeholder="Email Address"
							inputmode="email"
							type="text"
						/>

						<span v-if="v$.email.$error && submitted">
							<span
								id="email-error"
								v-for="(error, index) of v$.email.$errors"
								:key="index"
							>
								<small class="p-error p-text-bold">
									{{
										error.$message == "Value is required"
											? error.$message.replace("Value", "Email")
											: error.$message.replace(
													"Value is not a valid",
													"Invalid"
											  )
									}}
								</small>
							</span>
						</span>
					</div>

					<div class="p-field p-mb-3 p-col-12 p-sm-6">
						<label for="phoneNumber" class="p-text-bold">Phone Number *</label>

						<InputText
							id="phoneNumber"
							v-model="phoneNumber"
							placeholder="Phone Number"
							v-mask="'(###) ###-####'"
							inputmode="tel"
						/>

						<span v-if="v$.phoneNumber.$error && submitted">
							<span
								id="phoneNumber-error"
								v-for="(error, index) of v$.phoneNumber.$errors"
								:key="index"
							>
								<small class="p-error p-text-bold">
									{{
										error.$message == "Value is required"
											? error.$message.replace("Value", "Phone Number")
											: error.$message.replace(
													"This field should be at least 14 characters long",
													"Invalid phone number"
											  )
									}}
								</small>
							</span>
						</span>
					</div>
					<div
						class="p-field p-text-left p-d-flex p-flex-column p-jc-center p-ai-start p-col-12 p-md-6 p-mt-3"
					>
						<label class="p-text-bold">Special Instructions</label>
						<Textarea v-model="specialInstructionsTA" rows="2" cols="5" />
					</div>
				</div>
			</AccordionTab>
		</Accordion>
	</div>
</template>

<script>
import { useFormDataStore } from "../store/formData.js";
import { useVuelidate } from "@vuelidate/core";
import { required, email, minLength, minValue } from "@vuelidate/validators";
import gmapsInit from "@/utils/gmaps.js";

export default {
	name: "DeliveryLocationDetailsCard",
	data() {
		return {
			active: 0,
			submitted: false,
			locationTotalAmount: 72,
			cookiesQuantityDozens: 3,
			deliveryAddressTypeRB: "Residential",
			companyName: null,
			firstName: null,
			lastName: null,
			address: null,
			address2: null,
			// country: "Canada",
			postalCode_zip: null,
			city: null,
			selectedProvince: { name: "Saskatchewan", code: "SK" },
			phoneNumber: null,
			email: null,
			specialInstructionsTA: null,
			filteredCountries: null,
			filteredProvinceState: null,
			totalAmountOfAllLocations: null,

			autoCompleteService: null,
			geocoder: null,
			filteredAddresses: [],
			streetNumber: null,
			route: null,
		};
	},
	setup() {
		const store = useFormDataStore();

		return {
			v$: useVuelidate(),
			store,
		};
	},
	validations() {
		return {
			cookiesQuantityDozens: {
				required,
				minValue: minValue(3),
			},
			deliveryAddressTypeRB: { required },
			companyName: this.deliveryAddressTypeRB == "Company" ? { required } : {},
			firstName: { required },
			lastName: { required },
			address: { required },
			postalCode_zip: { required },
			city: { required },
			selectedProvince: { required },
			phoneNumber: {
				minLength: minLength(14),
				required,
			},
			email: {
				email,
			},
		};
	},
	async mounted() {
		let google = await gmapsInit();
		this.filteredProvinceState = [...this.store.provinceOptions];
		if (this.locationTotalAmount != null) {
			this.$emit(
				"locationTotalAmount",
				this.locationTotalAmount,
				this.locationNumber
			);
		}
		if (google) {
			this.autoCompleteService =
				new window.google.maps.places.AutocompleteService();
			this.geocoder = new window.google.maps.Geocoder();
		} else {
			console.error("Google Maps API error");
		}
	},
	computed: {
		canadaProvinceOptions() {
			return this.store.provinceOptions;
		},
	},
	props: {
		locationNumber: Number,
		validateForm: Number,
		validateAllLocationForms: Function,
	},
	watch: {
		async validateForm() {
			const isFormValid = await this.v$.$validate();
			this.submitted = true;
			if (!isFormValid) {
				this.validateAllLocationForms(false, this.locationNumber);
				this.active = 0;
			} else {
				// console.log("postal code from location card", this.postalCode_zip)
				this.store.setS1LocationsInfoData(
					{
						deliveryAddressType: this.deliveryAddressTypeRB,
						companyName: this.companyName,
						firstName: this.firstName,
						lastName: this.lastName,
						address: this.address,
						address2: this.address2,
						postalCode: this.postalCode_zip,
						city: this.city,
						region: this.selectedProvince.code,
						phoneNumber: this.phoneNumber,
						email: this.email,
						cookiesQuantityDozens: this.cookiesQuantityDozens,
						locationTotalAmount: this.locationTotalAmount,
						specialInstructions: this.specialInstructionsTA,
					},
					this.locationNumber
				);
				this.validateAllLocationForms(true, this.locationNumber);
			}
		},
		cookiesQuantityDozens() {
			this.locationTotalAmount = this.cookiesQuantityDozens * 24;
		},
		locationTotalAmount() {
			if (this.locationTotalAmount != null) {
				this.$emit(
					"locationTotalAmount",
					this.locationTotalAmount,
					this.locationNumber
				);
			}
		},
	},
	methods: {
		searchAddress(event) {
			let countrySearchCriteria = ["ca"];

			this.autoCompleteService.getPlacePredictions(
				{
					input: event.query,
					componentRestrictions: { country: countrySearchCriteria },
					types: ["address"],
				},
				this.addressSearchResults
			);
		},
		addressSearchResults(predictions, status) {
			if (status == "OK") {
				this.filteredAddresses = [];

				predictions.forEach((place) => {
					this.filteredAddresses.push({
						name: place.description,
						placeId: place.place_id,
						mainText: place.structured_formatting.main_text,
					});
				});
			}
		},
		populateFields(event) {
			this.model = event.value.mainText;

			this.geocoder
				.geocode({
					placeId: event.value.placeId,
				})
				.then((result) => {
					const geocodePayload = result.results[0];
					geocodePayload.address_components.forEach((component) => {
						if (component.types.includes("street_number")) {
							this.streetNumber = component.long_name;
						} else if (component.types.includes("route")) {
							this.route = component.long_name;
							this.address = `${this.streetNumber} ${this.route}`;
						} else if (component.types.includes("locality")) {
							this.city = component.long_name;
						} else if (
							component.types.includes("administrative_area_level_1")
						) {
							this.selectedProvince =
								this.store.provinceOptions[
									this.store.provinces.indexOf(component.long_name)
								];
						} else if (component.types.includes("postal_code")) {
							this.postalCode_zip = component.long_name;
						}
					});
				});
		},
	},
};
</script>

<style lang="scss" scoped></style>
